import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COUNTDOWN_FEATURE_KEY, CountDownState } from './count-down.reducer';

// Lookup the 'CountDown' feature state managed by NgRx
const getCountDownState = createFeatureSelector<CountDownState>(
  COUNTDOWN_FEATURE_KEY
);

const getSelectedCountDown = createSelector(
  getCountDownState,
  (state: CountDownState) => state.countDown
);

export const countDownQuery = {
  getSelectedCountDown
};
